import { useState } from 'react';
import * as Yup from 'yup';
import { withStyles, MaterialSymbol, FormikFieldData, TextField, CircleButton } from 'vopay';
import { useTranslation } from 'react-i18next';
import styles from './EmailField.module.scss';

const classes = withStyles(styles);

type EmailFieldProps = {
  emails: string[] | undefined;
  onAdd: (email: string) => void;
  onRemove: (email: string) => void;
} & FormikFieldData<string>;

export default function EmailField({ emails, onAdd, onRemove, ...formikData }: EmailFieldProps) {
  const [tmpEmail, setTmpEmail] = useState('');
  const { t } = useTranslation('translations', { keyPrefix: 'Elinx.Form.ELinxSettings' });
  const { onBlur, ...rest } = formikData;

  const emailValidationSchema = Yup.string().email().required();
  const isEmailValid = emailValidationSchema.isValidSync(tmpEmail);
  const isEmailUnique = !emails?.includes(tmpEmail);

  function addEmail() {
    if (!tmpEmail || !isEmailValid || !isEmailUnique) return;
    onAdd(tmpEmail);
    setTmpEmail('');
  }
  return (
    <>
      <TextField
        variant="outlineShadow"
        placeholder={t('AdditionalRecipientEmails.placeholder', { defaultValue: 'Enter Email Address' })}
        elementRight={
          <CircleButton icon="add" iconFill size="small" className={classes('circleButton')} onClick={addEmail} />
        }
        onKeyDown={(e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            addEmail();
          }
        }}
        onBlur={addEmail}
        {...rest}
        value={tmpEmail}
        onChange={(e) => setTmpEmail(e.target.value)}
      />
      <div className={classes('description')}>
        {t('AdditionalRecipientEmails.description', {
          defaultValue: 'Press Enter or click ‘+’ to add each email address.',
        })}
      </div>
      <div className={classes('multiselectOptionsContainer')}>
        {emails?.map(
          (email) =>
            !!email.trim() && (
              <div key={email} className={classes('multiselectOption')}>
                <span>{email}</span>
                <button
                  className={classes('removeButton')}
                  onClick={() => {
                    onRemove(email);
                  }}
                >
                  <MaterialSymbol icon="close" />
                </button>
              </div>
            ),
        )}
      </div>
    </>
  );
}
